<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
.container {
	margin-top: 20px;

	.zhidaoshu {
		width: 100%;
		height: auto;
	}
	.filename{
		font-weight: bold;
		font-size: 18px;
	}
}
</style>
<template>
	<div v-loading="loading">
		<div class="container">
			<img v-if="isImg(zhidaoshu)" class="zhidaoshu" :src="zhidaoshu" />
				<a target="_blank" class="filename" v-else :href="zhidaoshu">{{zhidaoshuName}}</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'gongdan_zhidao',
	components: {},
	props: {
		wo: null,
	},

	data() {
		return {
			wo: null,
			zhidaoshu: null,
			zhidaoshuName:null,
			loading: false,
		};
	},

	computed: {
		isImg(){
			return (zhidaoshu)=>{
				if(zhidaoshu==null){
					return false
				}
				let houzhui = zhidaoshu.split(".")[zhidaoshu.split(".").length-1]
				if(houzhui=='png'||houzhui=="jpg"||houzhui=="jpeg"||houzhui=="gif"){
					return true
				}
				
				return false
			}
		},
		woid() {
			return this.wo ? this.wo.id : null;
		},
	},
	watch: {
		woid: {
			handler(n, o) {
				this.getZhidaoshu();
			},
			immediate: true,
			deep: true,
		},
	},
	created() {},
	mounted() {},
	beforeDestroy() {},

	methods: {
		getZhidaoshu() {
			this.loading = true;
			let params = {
				docType: 1,
				inspectionType: 1,
				productionCode: this.wo.productionNo,
			};
			this.http
				.post('/production/qualitystandarddocattachfile/getOneOfParent', params)
				.then(res => {
					this.zhidaoshu = (process.env.NODE_ENV == "development" ? global.URL_DEV_PAGE_BASE_DOMAIN : global.URL_PROD_PAGE_BASE_DOMAIN) + res.filePath;
					this.zhidaoshuName = res.fileName
				})
				.catch(err => {
					this.utils.errorMessage(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>
